module.exports = __webpack_public_path__ + "static/media/solution-tube-a-full-open.6c0268d2.svg";